<script>
import SelectBox from '@/components/pc/radio/ipradio/atoms/SelectBox.vue'
import ToggleSwitch from '@/components/pc/radio/ipradio/atoms/ToggleSwitch.vue'
import SettingGroup from '@/components/pc/radio/ipradio/organisms/layout/SettingGroup.vue'
import SettingItem from '@/components/pc/radio/ipradio/organisms/layout/SettingItem.vue'
import { BC } from '@/components/pc/radio/ipradio/config/BCconstants'
import { useRadioSettingsStore } from '@/components/pc/radio/ipradio/stores/bcRadioSettings'

export default {
  components: {
    SelectBox,
    ToggleSwitch,
    SettingGroup,
    SettingItem
  },

  data() {
    // ========== 静的変数 ==========
    const selectboxOptions = {
      gpsReportIntervalTime: BC.OPTIONAL_FEATURES.GPS.GPS_REPORT_INTERVAL_TIME.map((value) => {
        return {
          label: `${value} 秒`,
          value: String(value),
        }
      }),
    }

    return {
      radioSettings: null,
      selectboxOptions,
      // ========== リアクティブ変数 ==========
      form: {
        selectbox: {
          gpsReportIntervalTime: selectboxOptions.gpsReportIntervalTime[0].value,
        },
      },
      setting: null
    }
  },

  computed: {
    BC() {
      return BC
    }
  },

  watch: {
    form: {
      handler() {
        // フォームの内容を端末設定データに変換して反映
        this.transForm2Setting()
        // 最新の状態をストアの仮保存端末設定情報にも適用
        this.radioSettings.saveTempSetting(this.setting)
      },
      deep: true
    }
  },

  created() {
    // ストアに仮保存済みの端末設定情報を取得する
    this.radioSettings = useRadioSettingsStore()
    this.setting = this.radioSettings.getTempSetting()
    this.transSetting2Form()
  },

  methods: {
    // ========== methods ==========
    transForm2Setting() {
      const data = this.setting.OptionalFeatures.GPS

      console.log('============================')
      console.log('before setting: ', JSON.parse(JSON.stringify(this.setting.OptionalFeatures.GPS)))

      data.GPSReportIntervalTime = this.form.selectbox.gpsReportIntervalTime

      console.log('after setting: ', JSON.parse(JSON.stringify(this.setting.OptionalFeatures.GPS)))
    },

    transSetting2Form() {
      const data = this.setting.OptionalFeatures.GPS

      console.log('============================')
      console.log('before form: ', JSON.parse(JSON.stringify(this.form)))

      this.form.selectbox.gpsReportIntervalTime = data.GPSReportIntervalTime

      console.log('after form: ', JSON.parse(JSON.stringify(this.form)))
    },

    handleSelect(value) {
      this.form.selectbox.gpsReportIntervalTime = Number(value)
    }
  }
}
</script>

<template>
    <SettingGroup>
      <SettingItem label="GPS レポートの間隔">
        <SelectBox
          :disabled="false"
          :options="selectboxOptions.gpsReportIntervalTime"
          :defaultValue="String(form.selectbox.gpsReportIntervalTime)"
          @update="handleSelect"
        />
      </SettingItem>
    </SettingGroup>
</template>
